<template>
  <div :class="['vsk', 'vsk-' + etat]" :title="infobulle">
    <span class="vsk-dot"></span>
    <span class="vsk-lbl">{{ libelle }}</span>
    <span v-if="etat === 'connecte' && transport === 'polling'" class="vsk-warn">
      <i class="ri-alert-line"></i>
    </span>
  </div>
</template>

<script>
import { PresenceSocket } from "@/service/presencesocket";

export default {
  /* eslint-disable */
  name: "voyantsocket",

  data() {
    return {
      etat: "connexion",   // connexion | connecte | reconnexion
      transport: "",
    };
  },

  computed: {
    libelle() {
      if (this.etat === "connecte") return "Temps réel actif";
      if (this.etat === "reconnexion") return "Reconnexion…";
      return "Connexion…";
    },
    infobulle() {
      if (this.etat === "connecte") {
        /* La sonde de proxy : 'polling' signifierait que le reverse proxy ne
           relaie pas l'Upgrade sur /socket.io/. */
        return this.transport === "polling"
            ? "Connecté, mais en mode dégradé (polling) : le serveur ne relaie pas le WebSocket."
            : "Connecté en WebSocket.";
      }
      if (this.etat === "reconnexion") return "Liaison perdue. Reconnexion automatique en cours.";
      return "Établissement de la liaison temps réel.";
    },
  },

  created() {
    /* Hors de data() : le socket n'a pas à être proxifié par Vue. */
    this.presence = new PresenceSocket();
  },

  mounted() {
    /* On OBSERVE le socket global : on ne l'ouvre pas, et on ne le fermera pas. */
    this.presence.observer((etat) => {
      this.etat = etat;
      this.transport = this.presence.transport();
    });
  },

  beforeUnmount() {
    /* Retire nos seuls écouteurs - surtout pas le socket de l'application. */
    this.presence.arreter();
  },
};
</script>

<style scoped>
.vsk {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 5px 11px; border-radius: 20px;
  border: 1px solid #e2e8f0; background: #fff;
  font-family: 'Segoe UI', system-ui, sans-serif;
  font-size: 11.5px; font-weight: 700; color: #64748b;
  cursor: default; user-select: none;
}

.vsk-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #94a3b8; flex-shrink: 0;
  transition: background .2s;
}

.vsk-connexion .vsk-dot { background: #94a3b8; animation: vsk-pulse 1.2s ease-in-out infinite; }

.vsk-connecte { border-color: #16a34a; color: #16a34a; }
.vsk-connecte .vsk-dot { background: #16a34a; box-shadow: 0 0 0 3px rgba(22,163,74,.18); }

.vsk-reconnexion { border-color: #d97706; color: #d97706; }
.vsk-reconnexion .vsk-dot { background: #d97706; animation: vsk-pulse .9s ease-in-out infinite; }

.vsk-warn { color: #d97706; font-size: 12px; display: inline-flex; }

@keyframes vsk-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: .3; }
}
</style>
